import { useState, useEffect } from 'react';
import { User } from "@/types"
// toast import removed as part of disabling real-time subscriptions

interface UseOvertimeSubscriptionProps {
  user: User | null;
  onDataChange: () => void;
}

export function useOvertimeSubscription({ user }: UseOvertimeSubscriptionProps) {
  const [isConnected, setIsConnected] = useState(false)
  // Channel ref removed as part of disabling real-time subscriptions
  
  // DISABLED REAL-TIME SUBSCRIPTION to prevent infinite loops
  useEffect(() => {
    if (!user) return
    
    // Set connected state to false since we're not using real-time
    setIsConnected(false)
    
    // Instead of real-time updates, we'll rely on manual refresh
    // This prevents the infinite loop of Supabase requests
    
    // No cleanup needed since we're not creating a subscription
  }, [user])
  
  // Manual refresh function disabled to prevent excessive API calls
  /*
  const manualRefresh = async () => {
    if (onDataChange) {
      try {
        await onDataChange();
      } catch (error) {
        console.error('Error refreshing data:', error);
      }
    }
  };
  */
  
  return { isConnected }
}
